import { createSelector } from '@ngrx/store';
import { LogoutDialogState } from './logout-dialog.state';
import { selectDialogs } from '../../+store';

/**
 * Selectors für den Logout-Dialog.
 */
export class LogoutDialogSelectors {
  private static readonly _slice = createSelector(
    selectDialogs,
    (state): LogoutDialogState => state.logoutDialog,
  );

  /**
   * Selector für den isOpen-Status.
   */
  public static readonly isOpen = createSelector(
    this._slice,
    (state) => state.isOpen,
  );
}
